import { Divider, Grid, Stack, Typography, useMediaQuery as useMediaQuerySM, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { Property } from "csstype";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { PdfViewer } from "../components/PdfViewer";
import { RootState } from "../state";
import { ActivityType, CaptionedImage, HorizontalPosition, Section, VideoLink } from "../types/activityType";

export const ActivityVisualizer = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const { id } = useParams();

    const activities = useSelector((state: RootState) => state.activities.array);

    const [selectedActivity, setSelectedActivity] = useState<ActivityType | undefined>(undefined);

    useEffect(() => {
        setSelectedActivity(activities.find((act) => act.id == id));
    }, [id, activities]);

    // const [activeStep, setActiveStep] = useState(0);
    // const [visualMode, setVisualMode] = useState(false);

    // const [skipped, setSkipped] = React.useState(new Set<number>());

    // const isStepOptional = (step: number) => {
    //     return step === 1;
    // };

    // const isStepSkipped = (step: number) => {
    //     return skipped.has(step);
    // };

    // const handleNext = () => {
    //     let newSkipped = skipped;
    //     if (isStepSkipped(activeStep)) {
    //         newSkipped = new Set(newSkipped.values());
    //         newSkipped.delete(activeStep);
    //     }

    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    //     setSkipped(newSkipped);
    // };

    // const handleBack = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // };

    // const handleSkip = () => {
    //     if (!isStepOptional(activeStep)) {
    //         // You probably want to guard against something like this,
    //         // it should never occur unless someone's actively trying to break something.
    //         throw new Error("You can't skip a step that isn't optional.");
    //     }

    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    //     setSkipped((prevSkipped) => {
    //         const newSkipped = new Set(prevSkipped.values());
    //         newSkipped.add(activeStep);
    //         return newSkipped;
    //     });
    // };

    // const handleReset = () => {
    //     setActiveStep(0);
    // };

    const matches = useMediaQuerySM(theme.breakpoints.up("sm"));

    const drawSection = (section: Section, index: number) => (
        <>
            <Typography marginTop={theme.spacing(2)} variant="h5" color="text.primary">
                {section.title}
            </Typography>
            <Typography variant="h6" color="text.secondary">
                {section.subtitle}
            </Typography>
            {/* <Typography variant="body1" color="text.primary">
                {section.mainText}
            </Typography> */}
            {section.videos !== undefined && (
                <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    style={{ marginTop: theme.spacing(1) }}
                >
                    {section.videos.map(drawVideo)}
                </Grid>
            )}
            {section.paragraphs?.map((paragraph) => (
                <Typography variant="body1" color="text.primary">
                    {paragraph.text}
                    {drawImage(paragraph.image, 0)}
                </Typography>
            ))}
            {section.pdfs?.map(drawPdf)}
            {section.images?.map(drawImage)}
            {/* <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime incidunt facilis hic quod vitae
                perspiciatis explicabo, corrupti totam ratione. Aut libero sapiente tempore at voluptatem autem officia
                adipisci, velit dolore. Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime incidunt facilis
                hic quod vitae perspiciatis explicabo, corrupti totam ratione. Aut libero sapiente tempore at voluptatem
                autem officia adipisci, velit dolore.
                <figure style={{ float: "right", margin: "16px 0px 16px 16px" }}>
                    <img src={"./assets/images/lunaPark.jpg"} loading="lazy" />
                    <figcaption style={{ textAlign: "center" }}>This is a caption</figcaption>
                </figure>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime incidunt facilis hic quod vitae
                perspiciatis explicabo, corrupti totam ratione. Aut libero sapiente tempore at voluptatem autem officia
                adipisci, velit dolore. Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime incidunt facilis
                hic quod vitae perspiciatis explicabo, corrupti totam ratione. Aut libero sapiente tempore at voluptatem
                autem officia adipisci, velit dolore. Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
                incidunt facilis hic quod vitae perspiciatis explicabo, corrupti totam ratione. Aut libero sapiente
                tempore at voluptatem autem officia adipisci, velit dolore. Lorem ipsum dolor sit amet consectetur
                adipisicing elit. Maxime incidunt facilis hic quod vitae perspiciatis explicabo, corrupti totam ratione.
                Aut libero sapiente tempore at voluptatem autem officia adipisci, velit dolore. Lorem ipsum dolor sit
                amet consectetur adipisicing elit. Maxime incidunt facilis hic quod vitae perspiciatis explicabo,
                corrupti totam ratione. Aut libero sapiente tempore at voluptatem autem officia adipisci, velit dolore.
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime incidunt facilis hic quod vitae
                perspiciatis explicabo, corrupti totam ratione. Aut libero sapiente tempore at voluptatem autem officia
                adipisci, velit dolore. Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime incidunt facilis
                hic quod vitae perspiciatis explicabo, corrupti totam ratione. Aut libero sapiente tempore at voluptatem
                autem officia adipisci, velit dolore. Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
                incidunt facilis hic quod vitae perspiciatis explicabo, corrupti totam ratione. Aut libero sapiente
                tempore at voluptatem autem officia adipisci, velit dolore.
            </p> */}
            <Divider sx={{ clear: "both" }} />
        </>
    );

    const drawVideo = (video: VideoLink, index: number) => (
        <>
            {video.position === HorizontalPosition.Left ? <></> : <Grid item xs={0} sm={2} md={3}></Grid>}
            {video.position === HorizontalPosition.Right ? <Grid item xs={0} sm={2} md={3}></Grid> : <></>}
            <Grid item xs={4} sm={4} md={6} height={matches ? "28vw" : "57vw"}>
                <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${video.id}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                />
            </Grid>
        </>
    );

    const drawPdf = (pdf: string, index: number) => {
        return <PdfViewer url={pdf} maxWidth={1000} />;
    };

    const drawImage = (image: CaptionedImage, index: number) => {
        if (image == undefined) return <></>;
        return image.caption == undefined ? (
            <img src={image.path} style={{ margin: theme.spacing(1) }} loading="lazy" />
        ) : (
            <figure
                style={
                    image.position == undefined ||
                    image.position === HorizontalPosition.Center ||
                    image.position === HorizontalPosition.undefined
                        ? {
                              margin: theme.spacing(1),
                              justifyContent: "center",
                              display: "flex",
                              clear: "both",
                              maxWidth: "100vw",
                          }
                        : {
                              margin: theme.spacing(
                                  1,
                                  image.position === HorizontalPosition.Left ? 1 : 0,
                                  1,
                                  image.position === HorizontalPosition.Left ? 0 : 1
                              ),
                              float: PositionToString(image.position),
                              maxWidth: "100vw",
                          }
                }
            >
                <Stack>
                    <img src={image.path} loading="lazy" />
                    <figcaption style={{ textAlign: "center" }}>{image.caption}</figcaption>
                </Stack>
            </figure>
        );
    };

    // const drawStep = (section: Section, index: number) => {
    //     const stepProps: { completed?: boolean } = {};
    //     const labelProps: {
    //         optional?: React.ReactNode;
    //     } = {};
    //     if (isStepOptional(index)) {
    //         labelProps.optional = <Typography variant="caption">Optional</Typography>;
    //     }
    //     if (isStepSkipped(index)) {
    //         stepProps.completed = false;
    //     }
    //     return (
    //         <Step key={section.title} {...stepProps}>
    //             <StepLabel {...labelProps}>
    //                 <Typography variant="h5">{section.title}</Typography>
    //             </StepLabel>
    //         </Step>
    //     );
    // };

    return (
        <>
            {selectedActivity !== undefined && (
                <Box padding={{ xs: 1, sm: 2 }}>
                    <Typography variant="h4" align="center" component="div">
                        {selectedActivity.title}
                    </Typography>
                    <Typography variant="body1" color="text.primary">
                        {selectedActivity.description}
                    </Typography>
                    {selectedActivity.content.map(drawSection)}
                    {/* {visualMode || selectedActivity.content.length <= 1 ? (
                        selectedActivity.content.map(drawSection)
                    ) : (
                        <Box sx={{ width: "100%" }}>
                            {!matches ? (
                                <MobileStepper
                                    variant="text"
                                    steps={selectedActivity.content.length}
                                    position="bottom"
                                    activeStep={activeStep}
                                    nextButton={
                                        <Button
                                            size="small"
                                            onClick={handleNext}
                                            disabled={activeStep === selectedActivity.content.length - 1}
                                        >
                                            Next
                                            {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                                        </Button>
                                    }
                                    backButton={
                                        <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                                            {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                                            Back
                                        </Button>
                                    }
                                />
                            ) : (
                                <Stepper activeStep={activeStep}>{selectedActivity.content.map(drawStep)}</Stepper>
                            )}
                            {activeStep === selectedActivity.content.length ? (
                                <>
                                    <Typography sx={{ mt: 2, mb: 1 }}>
                                        Tutti i passi sono stati completati, complimenti!
                                    </Typography>
                                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                                        <Box sx={{ flex: "1 1 auto" }} />
                                        <Button onClick={handleReset}>Reset</Button>
                                    </Box>
                                </>
                            ) : (
                                <>
                                    {matches ? (
                                        <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                                            <Button
                                                variant="contained"
                                                disabled={activeStep === 0}
                                                onClick={handleBack}
                                                sx={{ mr: 1 }}
                                            >
                                                Back
                                            </Button>
                                            <Box sx={{ flex: "1 1 auto" }} />
                                            {isStepOptional(activeStep) && (
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleSkip}
                                                    sx={{ mr: 1 }}
                                                >
                                                    Skip
                                                </Button>
                                            )}
                                            <Button variant="contained" onClick={handleNext}>
                                                {activeStep === selectedActivity.content.length - 1 ? "Finish" : "Next"}
                                            </Button>
                                        </Box>
                                    ) : (
                                        <></>
                                    )}
                                    {selectedActivity !== undefined &&
                                        activeStep >= 0 &&
                                        activeStep < selectedActivity.content.length &&
                                        drawSection(selectedActivity.content[activeStep], activeStep)}
                                </>
                            )}
                        </Box>
                    )} */}
                </Box>
            )}
        </>
    );
};
function PositionToString(position: HorizontalPosition): Property.Float {
    switch (position) {
        case HorizontalPosition.Left:
            return "left";
        case HorizontalPosition.Right:
            return "right";
    }

    return "unset";
}
